import { ToastContainer } from "react-toastify";
import DataTable from "react-data-table-component";
import Tippy from "@tippyjs/react";
import Spinner from "../loading/spinner";
import AcademicHeader from "../AcademicHeader";
import SidebarContext from "../sidebarcontext/SidebarContext";
import { useContext, useEffect, useRef, useState } from "react";
import { NavLink } from "react-router-dom";
import jsPDF from "jspdf";
import "jspdf-autotable";
import { Fetchdata } from "../hooks/getData";
import { GetEnglishDate } from "../hooks/dateConvertor";
import Calendar from "@sbmdkl/nepali-datepicker-reactjs";
import "@sbmdkl/nepali-datepicker-reactjs/dist/index.css";

export default function AttendanceState() {
    const searchInput = useRef("");
    const { todayDate, customStylesForImage, AcademicYear, appURL } = useContext(SidebarContext);
    // console.log('todayDate', todayDate)
    const userinfo = JSON.parse(localStorage.getItem("userInfo"));

    const [selectedDate, setSelectedDate] = useState(todayDate)
    // console.log('selectedDate', selectedDate);

    const [attendanceStatusData, setAttendanceStatusData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [filteredData, setFilteredData] = useState([]);

    useEffect(() => {
        getAttendanceStatus();
    }, [selectedDate])

    const getAttendanceStatus = () => {
        setLoading(true);
        const dataForm = {
            SchID: userinfo.SchID,
            UserID: userinfo.UserID?.toString(),
            AuthCode: userinfo.AuthCode,
            Flag: "S",
            DFlag: "TA",
            Values: selectedDate,
            Type: "POST",
            FetchURL: `${appURL}api/admin/attendance-repsum`,
        };
        console.log('dataForm', dataForm);
        Fetchdata(dataForm).then(function (result) {
            if (result.StatusCode === 200) {
                setAttendanceStatusData(result.AttenLst);
                setFilteredData(result.AttenLst);
                setLoading(false);
            } else {
                console.log(result?.Message)
                setLoading(false);
            }
        });
    }

    const handleDateChange = ({ adDate }) => {
        // console.log('bsDate', adDate);
        setSelectedDate(adDate);
    };

    const searchHandler = (e) => {
        e.preventDefault();

        const srchQuery = searchInput.current.value.toLowerCase();
        if (srchQuery) {
            let srchResult = attendanceStatusData.filter((list) => {
                return list["FullName"].toLowerCase().includes(srchQuery);
            });
            setFilteredData(srchResult);
        } else {
            setFilteredData(attendanceStatusData);
        }
    };

    /* This is for export csv */

    const dataToExcel = filteredData.map((d, i) => ({
        "Roll No.": d.RollNo,
        "Full Name": d.FullName,
        Status: d.AttenStatus === "P" ? "Present" : "Absent",
    }));

    const toExcel = () => {
        import("xlsx").then((xlsx) => {
            const worksheet = xlsx.utils.json_to_sheet(dataToExcel);
            var wscols = [{ wch: 5 }, { wch: 20 }, { wch: 15 }];
            worksheet["!cols"] = wscols;
            const workbook = { Sheets: { data: worksheet }, SheetNames: ["data"] };
            const excelBuffer = xlsx.write(workbook, {
                bookType: "xlsx",
                type: "array",
            });
            saveAsExcelFile(excelBuffer, "Attendance");
        });
    };

    const saveAsExcelFile = (buffer, fileName) => {
        import("file-saver").then((module) => {
            if (module && module.default) {
                let EXCEL_TYPE =
                    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
                let EXCEL_EXTENSION = ".xlsx";
                const data = new Blob([buffer], {
                    type: EXCEL_TYPE,
                });

                module.default.saveAs(
                    data,
                    fileName + "_" + "export" + EXCEL_EXTENSION
                );
            }
        });
    };

    //end

    //This is to export pdf

    const dataWithIndex = filteredData.map((d, i) => ({
        ...d,
        Index: i + 1,
        Status: d.AttenStatus === "P" ? "Present" : "Absent",
    }));

    const cols = [
        { header: "Roll No", field: "RollNo" },
        { header: "Full Name", field: "FullName" },
        { header: "Status", field: "Status" },
    ];

    const exportColumns = cols.map((col) => ({
        title: col.header,
        dataKey: col.field,
    }));

    const toPdf = () => {
        const doc = new jsPDF("p", "pt", "a4", true);

        var midPage = doc.internal.pageSize.getWidth() / 2;

        // doc.addImage(`${userinfo.SchPhoto}`, "JPG", 40, 40, 70, 60);

        doc.setFontSize(18);
        doc.text(`${userinfo.SchName}`, midPage, 50, null, null, "center");

        doc.setFontSize(15);
        doc.text(`${userinfo.SchAddress}`, midPage, 68, null, null, "center");

        doc.setFontSize(10);
        doc.text(
            `Tel:${userinfo.Phone}, E-mail:${userinfo.Email}`,
            midPage,
            85,
            null,
            null,
            "center"
        );

        doc.autoTable({
            startY: 100,
            theme: "grid",
            columns: exportColumns,
            body: dataWithIndex,
        });
        doc.save("Attendance.pdf");
    };
    //end

    const columns = [
        {
            name: "S.No.",
            width: "90px",
            center: true,
            cell: (row, index) => index + 1
        },
        {
            name: "Class",
            selector: (row) => row.Class,
        },
        { name: 'Section', selector: (row) => row.Section },
        { name: 'Class Teacher', selector: (row) => row.ClassTeacher },
        {
            name: "Status",
            // grow: 0,
            width: "100px",
            center: true,
            selector: (row) => {
                return (
                    <>
                        {row.IsTaken?.toUpperCase() === "N" ? (
                            <div className="badge badge-danger"> Not Taken </div>
                        ) : (
                            <div className="badge badge-success">Taken</div>
                        )}
                    </>
                    //
                );
            },
        },
    ];

    return (
        <>
            <ToastContainer
                position="top-center"
                autoClose={3000}
                hideProgressBar={true}
                newestOnTop={false}
                closeOnClick
                rtl={false}
            />

            <div className="container-fluid classatten-wrapper  mt-3 ps-4 pe-4">
                <div className="row mt-3">
                    <div className="page-header">
                        <div>
                            <h4>Attendance</h4>
                        </div>
                        <div className="page-date">
                            <div className="sec-content">
                                <AcademicHeader
                                    todayDate={todayDate}
                                    AcademicYear={AcademicYear}
                                />
                            </div>
                        </div>
                    </div>
                    <div
                        className="d-flex justify-content-between"
                        style={{
                            marginBottom: "1rem",
                            backgroundColor: "#f4f8fb",
                            marginLeft: "14px",
                            padding: "0",
                            maxWidth: "1230px",
                        }}
                    >
                        <div className="d-flex">
                            <NavLink
                                className="nav-link"
                                to="/attendance"
                                style={{
                                    padding: "0.75rem 1rem",
                                    textAlign: "center",
                                    cursor: "pointer",
                                }}
                                activeClassName="active"
                            >
                                <i
                                    className="fa fa-file-text-o mx-1 icon"
                                    aria-hidden="true"
                                ></i>
                                <b>Attendance</b>
                            </NavLink>

                            <NavLink
                                className="nav-link"
                                to="/attendance-status"
                                style={{
                                    padding: "0.75rem 1rem",
                                    textAlign: "center",
                                    cursor: "pointer",
                                }}
                                activeClassName="active"
                            >
                                <i
                                    className="fa fa-file-text-o mx-1 icon"
                                    aria-hidden="true"
                                ></i>
                                <b>Attendance Status</b>
                            </NavLink>

                            <NavLink
                                className="nav-link"
                                to="/absent"
                                style={{
                                    padding: "0.75rem 1rem",
                                    textAlign: "center",
                                    cursor: "pointer",
                                }}
                                activeClassName="active"
                            >
                                <i
                                    className="fa fa-file-text-o mx-1 icon"
                                    aria-hidden="true"
                                ></i>
                                <b>Absent</b>
                            </NavLink>

                            <NavLink
                                to="/monthlyReport"
                                className="nav-link"
                                style={{
                                    padding: "0.75rem 1rem",
                                    textAlign: "center",
                                    cursor: "pointer",
                                }}
                                activeClassName="active"
                            >
                                <i
                                    className="fa fa-file-text-o mx-1 icon"
                                    aria-hidden="true"
                                ></i>
                                <b>Report</b>
                            </NavLink>
                            <NavLink
                                to="/monthlySummary"
                                className="nav-link"
                                style={{
                                    padding: "0.75rem 1rem",
                                    textAlign: "center",
                                    cursor: "pointer",
                                }}
                                activeClassName="active"
                            >
                                <i
                                    className="fa fa-file-text-o mx-1 icon"
                                    aria-hidden="true"
                                ></i>
                                <b>Summary</b>
                            </NavLink>
                        </div>
                    </div>

                    <div className="sec-dataTable content-section main-content">
                        <div className="upper-dataTbl">
                            <div className="exportDiv">
                                <Tippy content="Excel">
                                    <button className="exportButtons  mx-2" onClick={toExcel}>
                                        <i className="bi bi-file-earmark-excel-fill exportButtonIconsExcel"></i>
                                    </button>
                                </Tippy>

                                <Tippy content="PDF">
                                    <button className="exportButtons" onClick={toPdf}>
                                        <i className="bi bi-file-earmark-pdf-fill exportButtonIconsPdf"></i>
                                    </button>
                                </Tippy>
                            </div>
                        </div>
                        <hr className="new-hr-new" />
                        <div className="d-flex" style={{ marginBottom: "1rem" }}>
                            <div className="col-md-2 col-sm-2 col-lg-2 dropdown">
                                <label className="list-label">Select Date</label>
                                <Calendar
                                    className="form-control form-control-sm mb-1"
                                    dateFormat="YYYY/MM/DD"
                                    theme="default"
                                    language="en"
                                    onChange={handleDateChange}
                                />
                                <i className="fas fa-angle-down notificationpositon"></i>
                            </div>
                            <div className="d-flex mt-3 justify-content-end absent-student-list flex-grow-1">
                                <div className="d-flex">
                                    <input
                                        placeholder="Search"
                                        ref={searchInput}
                                        type="text"
                                        className="form-control form-control-sm searchField"
                                        onChange={searchHandler}
                                    />
                                </div>
                            </div>
                        </div>
                        {loading ? (
                            <Spinner />
                        ) : (
                            <DataTable
                                columns={columns}
                                data={filteredData}
                                customStyles={customStylesForImage}
                                pagination
                                fixedHeader
                                fixedHeaderScrollHeight="280px"
                                highlightOnHover
                                pointerOnHover
                                responsive
                                dense
                                striped
                            >
                            </DataTable>
                        )}
                    </div>
                </div>
            </div>
        </>
    );
}